<template>
  <stage-card-info-list class="screening-results-semi-circle">
    <template #header> Results </template>
    <template #content>
      <div class="horizontal-group">
        <div class="vertical-group">
          <div class="header">Total Relevant</div>
          <div class="count">{{ relevantCountText }}</div>
          <div class="pct">{{ relevantPctText }}</div>
        </div>
        <semi-circle-chart
          :data="chartData"
          :width="150"
          :height="67"
        />
      </div>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import SemiCircleChart from '@/components/Common/SemiCircleChart';
import { Review } from '@/models';

export default {
  name: 'ScreeningResultsSemiCircle',
  components: {
    SemiCircleChart,
    StageCardInfoList,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    relevantCountText() {
      return this.review.screeningOutcomeSummary.relevantCount.toLocaleString();
    },
    relevantPctText() {
      const { relevantCount } = this.review.screeningOutcomeSummary;
      const { screenedCount } = this.review.screeningProgressSummary;
      let pct = (relevantCount / screenedCount) * 100;
      if (Number.isNaN(pct)) {
        pct = 0;
      }
      return `(${pct.toLocaleString(undefined, {
        maximumFractionDigits: 1,
      })}%)`;
    },
    chartData() {
      const { screenedCount } = this.review.screeningProgressSummary;
      if (screenedCount === 0) {
        return [
          {
            label: 'Pending',
            value: this.review.screeningProgressSummary.totalReferenceCount(),
            color: '#E0E0E0',
          },
        ];
      }
      return [
        {
          label: 'Relevant',
          value: this.review.screeningOutcomeSummary.relevantCount,
          color: '#19AA55', // success
        },
        {
          label: 'Not Sure',
          value: this.review.screeningOutcomeSummary.notSureCount,
          color: '#FFC107', // warning
        },
        {
          label: 'Not Relevant',
          value: this.review.screeningOutcomeSummary.notRelevantCount,
          color: '#EF5050', // error
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.screening-results-semi-circle {
  .horizontal-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .header {
    font-size: 14px;
    font-weight: 500;
    color: map-get($grey, 'darken-2');
  }

  .count {
    font-size: 16px;
    font-weight: 600;
  }

  .pct {
    font-size: 12px;
    font-weight: 600;
    color: map-get($grey, 'lighten-1');
  }

  .vertical-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .relevant-pct-text {
    display: grid;
    justify-content: center;
  }
}
</style>
